"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORGANIZATIONS_TABLE_KEYS = void 0;
exports.ORGANIZATIONS_TABLE_KEYS = {
    DISCONNECT: 'disconnect',
    IS_SANDBOX: 'isSandbox',
    LAST_SYNC: 'lastSync',
    ORGANIZATION_NAME: 'organizationName',
    PACKAGE_TAGGING: 'packageTagging',
    REAUTHORIZE: 'reauthorize',
    SYNC_STATUS: 'syncStatus'
};
//# sourceMappingURL=ORGANIZATIONS_TABLE_KEYS.js.map